// Module
var code = " <span class=\"dv-countdown-countdown\"> {{ vm.getTimeLeft() }} </span> ";
// Exports
module.exports = code;